import script from "./Graphic.vue?vue&type=script&setup=true&lang=ts"
export * from "./Graphic.vue?vue&type=script&setup=true&lang=ts"

import "./Graphic.vue?vue&type=style&index=0&id=f442c7e8&lang=scss"

const __exports__ = script;

export default __exports__